<script>
	import BarChartComparison from '$lib/Components/BarChartComparison/BarChartComparison.svelte';

	const chartData = {
		labelLeft: 'AVERAGE COST',
		labelBottom: 'STC RATING',
		bar: ['0', '10', '20', '30', '40', '50'],
		content: [
			{
				title: 'INDOWONE INSERT: $372',
				color: 'blue',
				percent: 90,
			},
			{
				title: 'SINGLE-PANE: $450',
				color: 'grey',
				percent: 48,
			},
			{
				title: 'DOUBLE-PANE: $539',
				color: 'grey-medium',
				percent: 58,
			},
			{
				title: 'TRIPLE-PANE: $766',
				color: 'grey-dark',
				percent: 95,
			},
		],
	};
</script>

<BarChartComparison {...chartData} />
